module.exports = __webpack_public_path__ + "img/icon-bills.0a627525.svg";